import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./C212DynamicPositioningFuelConsumption.scss"

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, cSectionFormFields } from "../../Constants";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const C212DynamicPositioningFuelConsumption = forwardRef(({ c212DynamicPositioning,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    const { dirtyFields } = formState;
    const isC212Dirty = !!(dirtyFields?.c212 && Object.keys(dirtyFields.c212).length > 0);

    useEffect(() => {
        if (c212DynamicPositioning) {
            reset(prev => ({ ...prev, c212: c212DynamicPositioning }));
        }
    }, [c212DynamicPositioning, reset]);

    AutoSave(ref, [], async () => {
        if (!isC212Dirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c212");
        const payload = {
            ...cSectionFormFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const c212DynamicPositioningFuelConsumption = await callApi({
                method: "POST",
                url: API_ROUTES.C212(vesselMstId),
                data: payload,
            });
            if (c212DynamicPositioningFuelConsumption?.isSuccess) {
                emitToasterMsg("success", "Table C.2.12", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c212: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.2.12", c212DynamicPositioningFuelConsumption?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.2.12", error.errorMessage);
        }
    };

    return (
        <div className="c212-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Determining and recording the fuel consumption for dynamic positioning</h6>
                </MDBCol>
            </MDBRow>

            {cSectionFormFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c212.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c212_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c212_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                    disabled={!isC212Dirty}
                >Save</Button>
            </div>
        </div>
    );
});

export default C212DynamicPositioningFuelConsumption;